__turbopack_context__.v({
  "center": "tabs-module-scss-module__ccvktW__center",
  "end": "tabs-module-scss-module__ccvktW__end",
  "fieldset": "tabs-module-scss-module__ccvktW__fieldset",
  "input": "tabs-module-scss-module__ccvktW__input",
  "label": "tabs-module-scss-module__ccvktW__label",
  "small": "tabs-module-scss-module__ccvktW__small",
  "tab": "tabs-module-scss-module__ccvktW__tab",
  "tabText": "tabs-module-scss-module__ccvktW__tabText",
  "vertical": "tabs-module-scss-module__ccvktW__vertical",
  "wrapper": "tabs-module-scss-module__ccvktW__wrapper",
});
